export const en = {
  // Shared category display labels (hardcoded slug→label maps, NOT data)
  'categories.marketPeripheral': 'Market Peripheral',
  'categories.analysis': 'Analysis',
  'categories.insights': 'Insights',

  // Header (MainLayout SiteHeader)
  'header.eyebrow': 'Market research',
  'header.searchPlaceholder': 'Search research',
  'header.account': 'Account',
  'header.logIn': 'Log in',
  'header.register': 'Register',
  'header.subscribe': 'Subscribe',
  'header.toggleMenu': 'Toggle menu',
  'nav.about': 'About',

  // Footer (MainLayout SiteFooter + FooterNewsletterSection)
  'footer.research': 'Research',
  'footer.firm': 'Firm',
  'footer.methodology': 'Methodology',
  'footer.disclosures': 'Disclosures',
  'footer.orderReport': 'Order a Report',
  'footer.newsletterKicker': 'Weekly briefing',
  'footer.newsletterHeading': 'Stay ahead of the market narrative.',
  'footer.newsletterBody': "Get the week's most important market setup, thesis changes, and sector signals in one premium note.",
  'footer.emailPlaceholder': 'Enter your email',
  'footer.emailAriaLabel': 'Email address',
  'footer.joinLetter': 'Join the letter',
  'footer.blurb': 'Premium equity research and market commentary for serious self-directed investors.',
  'footer.copyright': '© {year} Ahead Metric. All rights reserved.',
  'footer.disclaimerLabel': 'Disclaimer:',
  'footer.disclaimerText': 'Content is for educational purposes only. Not financial advice. Consult a professional before investing.',

  // Publication components
  'publication.feedbackKicker': 'Reader feedback',
  'publication.feedbackHeading': 'Send feedback',
  'publication.feedbackBody': 'Flag weak assumptions, request deeper coverage, or tell us what you want tracked next.',
  'publication.feedbackOpen': 'Open feedback form',
  'publication.feedbackComingSoon': 'Feedback form coming soon',
  'publication.newsletterHeading': 'Get the weekly market brief',
  'publication.newsletterDescription': 'A concise note on leadership, rotation, and risk every week.',
  'publication.newsletterKicker': 'Newsletter',
  'publication.newsletterEmailPlaceholder': 'Email address',
  'publication.newsletterSubscribe': 'Subscribe',
  'publication.share': 'Share',
  'publication.copyLink': 'Copy link',
  'publication.copiedLink': 'Copied link',
  'publication.trustKicker': 'Research trust',
  'publication.trustEducationalOnly': 'Educational content only.',
  'publication.trustNotAdvice': 'This note is research and commentary, not individualized financial advice.',
  'publication.trustLastReviewed': 'Last reviewed for publication on {date}.',
  'publication.trustGuidance': 'Use this work to frame risk and thesis quality, then validate against your own mandate and time horizon.',

  // HomePage
  'home.heroKicker': 'Premium wealth publication',
  'home.latestMarketView': 'Latest market view',
  'home.heroTitle': 'Clear, disciplined market research for serious self-directed investors.',
  'home.heroSubcopy': 'Ahead Metric turns daily market movement into a calmer research workflow: what changed, why it matters, and where the risk sits now.',
  'home.readLatest': 'Read the latest analysis',
  'home.archiveCta': 'Market Peripheral archive',
  'home.editorialFocus': 'Editorial focus',
  'home.featuredResearch': 'Featured research',
  'home.focusBody': 'A premium reading experience centered on market structure, thesis quality, and trustable interpretation.',
  'home.focusDailyBrief': 'Daily market brief',
  'home.focusDeepDive': 'Deep-dive stock analysis',
  'home.focusSectorMacro': 'Sector and macro insights',
  'home.leadNote': 'Lead note',
  'home.emptyLead': 'New research will appear here as the publication library grows.',
  'home.emptyFresh': 'Fresh analysis appears here as soon as new markdown content is indexed.',
  'home.piecesAvailable': '{count} pieces available',
  'home.openResearch': 'Open research',
  'home.atAGlance': 'At a glance',
  'home.coverageMap': 'Coverage map',
  'home.totalNotes': 'Total published notes',
  'home.cadence': 'Publication cadence',
  'home.ongoing': 'Ongoing',
  'home.trustBody': 'Trust comes from recency, clarity, and a visible research archive, not inflated claims.',
  'home.library': 'Library',
  'home.viewAll': 'View all research',
  'home.emptyArchive': 'No articles found. Add markdown files to build the publication archive.',
  'home.recentNotes': 'Recent notes',
  'home.whatChanged': 'What just changed',
  'home.seeArchive': 'See archive',

  // CategoryPage
  'category.marketPeripheralDesc': 'Expert insights into market trends, sector analysis, and economic indicators.',
  'category.analysisDesc': 'Strategies and tools for managing and optimizing your investment portfolio.',
  'category.insightsDesc': 'Deep-dive perspectives and commentary on markets, economics, and investment themes.',
  'category.fallbackTitle': 'Articles',
  'category.fallbackDesc': 'Browse our content',
  'category.emptyHeading': 'No articles yet',
  'category.emptyBody': 'Articles in this category will appear here.',
  'category.backHome': '← Back to Home',
  'category.oneArticleFound': '1 article found',
  'category.articlesFound': '{count} articles found',

  // ArticleDetailPage
  'article.notFound': 'Article not found',
  'article.loadFailed': 'Failed to load article',
  'article.loading': 'Loading article…',
  'article.notFoundBody': "The article you're looking for doesn't exist.",
  'article.returnHome': 'Return to home',
  'article.backHome': 'Back to Home',
  'article.related': 'Related Articles',
  'article.readMore': 'Read more →',

  // AboutPage
  'about.kicker': 'About',
  'about.title': 'About Ahead Metric',
  'about.subtitle': 'Making stock market education accessible to everyone',
  'about.missionHeading': 'Our Mission',
  'about.missionP1': 'Ahead Metric was founded with a simple belief: quality investment education should be accessible to everyone, not just institutional investors and hedge fund managers.',
  'about.missionP2': 'We provide in-depth market analysis, stock research, and portfolio strategies tailored for three key audiences: beginners learning the fundamentals, day traders seeking tactical opportunities, and long-term investors building wealth over time.',
  'about.differenceHeading': 'What Sets Us Apart',
  'about.differenceBody': 'Unlike sensationalist financial media, we focus on education and empowerment. Our content is grounded in rigorous analysis. Every article includes real data, transparent methodologies, and practical takeaways.',
  'about.principlesKicker': 'Editorial principles',
  'about.valueDataTitle': 'Data-Driven Analysis',
  'about.valueDataDesc': 'Every recommendation is backed by thorough research and quantitative analysis.',
  'about.valueUnbiasedTitle': 'Unbiased Insights',
  'about.valueUnbiasedDesc': 'We prioritize education over sensationalism. No hidden agendas.',
  'about.valueAccessibleTitle': 'Accessible Learning',
  'about.valueAccessibleDesc': 'Complex concepts explained simply for investors at all levels.',
  'about.disclaimerHeading': 'Important Disclaimer',
  'about.disclaimerStrong': 'Ahead Metric provides educational content only.',
  'about.disclaimerBody': 'Nothing on this site constitutes financial, investment, legal, or tax advice. All content is for informational purposes and should not be relied upon for making investment decisions. Stock markets are inherently risky, and past performance does not guarantee future results. Always consult with a qualified financial advisor before making any investment decisions.',

  // Shared validation (zod schema messages hold these KEYS; translated at render)
  'validation.emailInvalid': 'Enter a valid email address',
  'validation.required': 'Required',
  'validation.passwordMin': 'Password must be at least 8 characters',
  'validation.passwordsMismatch': 'Passwords do not match',

  // Auth shared
  'auth.emailLabel': 'Email address',
  'auth.recoveryKicker': 'Account recovery',
  'auth.passwordMinPlaceholder': 'At least 8 characters',

  // LoginPage
  'login.kicker': 'Sign in',
  'login.title': 'Welcome back',
  'login.subcopy': 'Sign in to access your AheadMetric account.',
  'login.invalidCredentials': 'Invalid email or password.',
  'login.passwordLabel': 'Password',
  'login.passwordPlaceholder': 'Your password',
  'login.forgotPassword': 'Forgot password?',
  'login.submitting': 'Signing in…',
  'login.submit': 'Sign in',
  'login.noAccount': "Don't have an account?",
  'login.createOne': 'Create one',

  // RegisterPage
  'register.kicker': 'Create account',
  'register.title': 'Join AheadMetric',
  'register.subcopy': 'Premium equity research and market commentary for serious investors.',
  'register.emailExists': 'An account with this email already exists.',
  'register.passwordLabel': 'Password',
  'register.submitting': 'Creating account…',
  'register.submit': 'Create account',
  'register.haveAccount': 'Already have an account?',
  'register.logIn': 'Log in',

  // ForgotPasswordPage
  'forgot.successKicker': 'Check your email',
  'forgot.successTitle': 'Reset link sent',
  'forgot.successBody': "If an account exists for that address, you will receive a password reset link shortly. Check your spam folder if it doesn't arrive within a few minutes.",
  'forgot.backToSignIn': 'Back to sign in',
  'forgot.title': 'Reset your password',
  'forgot.subcopy': "Enter your email address and we'll send you a link to reset your password.",
  'forgot.submitting': 'Sending…',
  'forgot.submit': 'Send reset link',

  // ResetPasswordPage
  'reset.title': 'Set a new password',
  'reset.subcopy': 'Choose a strong password for your account.',
  'reset.newPasswordLabel': 'New password',
  'reset.confirmLabel': 'Confirm new password',
  'reset.confirmPlaceholder': 'Repeat your new password',
  'reset.submitting': 'Updating…',
  'reset.submit': 'Update password',

  // EmailConfirmationPage
  'emailConfirm.kicker': 'Verify your email',
  'emailConfirm.title': 'Check your inbox',
  'emailConfirm.body': 'We sent a confirmation link to your email address. Click the link to activate your account and get started.',
  'emailConfirm.alreadyConfirmed': 'Already confirmed?',
  'emailConfirm.signIn': 'Sign in',

  // IntakeForm — labelKeys only; submitted option VALUES stay English
  'intake.horizon3m': '3 months',
  'intake.horizon6m': '6 months',
  'intake.horizon12m': '12 months',
  'intake.horizon2to3y': '2–3 years',
  'intake.horizon5yPlus': '5+ years',
  'intake.positionLong': 'Long',
  'intake.positionShort': 'Short',
  'intake.positionConsidering': 'Considering',
  'intake.positionHolding': 'Holding',
  'intake.positionNone': 'No position',
  'intake.capacityError': "We're at capacity right now. Please check back in 24–48 hours.",
  'intake.genericError': 'Something went wrong. Please try again.',
  'intake.kicker': 'Order a Stock Analysis',
  'intake.heading': 'Get a Customized Report',
  'intake.body': "Submit your stock and question. We'll deliver a personalized A/B/C scenario analysis within 24 hours.",
  'intake.tickerLabel': 'Ticker Symbol',
  'intake.companyLabel': 'Company Name',
  'intake.questionLabel': 'Your Question ({count}/200)',
  'intake.questionPlaceholder': 'Is this a good entry point given current valuations and macro conditions?',
  'intake.horizonLabel': 'Time Horizon',
  'intake.positionLabel': 'Your Position',
  'intake.emailLabel': 'Email Address',
  'intake.emailHelper': 'Report delivered here within 24 hours.',
  'intake.oneTime': 'One-time payment',
  'intake.redirecting': 'Redirecting...',
  'intake.continuePayment': 'Continue to Payment →',
  'validation.emailInvalidShort': 'Enter a valid email',

  // OrderPage
  'order.step1Label': '1. Submit',
  'order.step1Desc': 'Enter your ticker, your specific question, and your investment horizon.',
  'order.step2Label': '2. Pay',
  'order.step2Desc': 'Checkout via Stripe. $19 flat. No subscription.',
  'order.step3Label': '3. Receive',
  'order.step3Desc': 'Your personalized A/B/C scenario analysis arrives by email within 24 hours.',
  'order.kicker': 'Personalized Stock Analysis',
  'order.title': 'Know your stock before you act',
  'order.subcopy': 'Submit a ticker and your question. Get a customized A/B/C scenario analysis — written by a human analyst — within 24 hours.',
  'order.meta': '$19 per report · Max 3 concurrent orders',
  'order.howItWorks': 'How It Works',

  // ConfirmationPage
  'confirmation.awaitingHeadline': 'Awaiting Payment',
  'confirmation.awaitingBody': 'Complete your payment to confirm the order.',
  'confirmation.confirmedHeadline': 'Order Confirmed',
  'confirmation.confirmedBody': "Payment received. Your analysis is in the queue — you'll receive it within 24 hours.",
  'confirmation.inProgressHeadline': 'Analysis in Progress',
  'confirmation.inProgressBody': 'Our analyst is working on your report. Delivery within the next few hours.',
  'confirmation.deliveredHeadline': 'Report Delivered',
  'confirmation.deliveredBody': 'Your analysis has been sent to your email. Check your inbox.',
  'confirmation.refundedHeadline': 'Order Refunded',
  'confirmation.refundedBody': 'This order has been refunded. Contact us if you have questions.',
  'confirmation.expiredHeadline': 'Order Expired',
  'confirmation.expiredBody': 'The payment window expired. Submit a new order to get started.',
  'confirmation.noToken': 'No order token found in URL.',
  'confirmation.loadError': 'Could not load order status.',
  'confirmation.loading': 'Loading order status...',
  'confirmation.kicker': 'Order Status',
  'confirmation.ticker': 'Ticker',
  'confirmation.status': 'Status',
  'confirmation.ordered': 'Ordered',
  'confirmation.paid': 'Paid',
  'confirmation.delivered': 'Delivered',
  'confirmation.sentNotice': 'Report sent. Check your inbox at the email you provided.',
  'confirmation.pollingNotice': 'This page updates automatically every 5 seconds.',
  'confirmation.statusPendingPayment': 'Pending Payment',
  'confirmation.statusPaid': 'Paid',
  'confirmation.statusInProgress': 'In Progress',
  'confirmation.statusDelivered': 'Delivered',
  'confirmation.statusRefunded': 'Refunded',
  'confirmation.statusAbandoned': 'Abandoned',

  // NotFound
  'notFound.heading': 'Page Not Found',
  'notFound.body': "Sorry, the page you are looking for doesn't exist or has been moved.",
  'notFound.goHome': 'Go Home',
  'notFound.goBack': 'Go Back',

  // MarkdownRenderer
  'markdown.articleImage': 'Article image',
  'markdown.zoomImage': 'Zoom image: {alt}',
  'markdown.imagePreview': 'Image preview',

  // Ads (AdSlot)
  'ads.label': 'ADVERTISEMENT',
} as const;

export type MessageKey = keyof typeof en;
